module.exports = __webpack_public_path__ + "img/pms1.276fb7fe.jpg";